import styled from "styled-components";
import { colors } from "constants/colors";
import { BasicSectionContainer } from "../../../../../style";
import { bookingChangesStyles } from "../../styles";

export const AccountContentContainer = styled(BasicSectionContainer)`
  ${bookingChangesStyles}

  .cardContent {
    .datesText {
      font-size: 16px;
      font-weight: 400;
      color: ${colors.almostBlack};
      line-height: 24px;
    }
    .changeNote {
      margin-top: 32px;
      font-style: italic;
      color: ${colors.secLabel};
    }
    .applyChanges {
      margin-top: 32px;
    }

    .buttonContainer {
      margin-top: 32px;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-direction: row;
      align-content: center;
      gap: 24px;
      .cancelBt {
        font-size: 16px;
        font-weight: 700;
        color: ${colors.hoverBlue};
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
`;
